import {
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import Modal from "react-awesome-modal";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import init from "../../helpers/WindowToken";
import Constants from "../Variables/Constants";

export default class Testimonials extends Component {
  state = {
    open: false,
    testimonials: [],
    data: [],
    notifyStatus: false,

    notifyDelete: false,
    visible: false,
    delLoading: false,
    rowId: 0,
    status: "",
    active: 1,
    perPage: "10",
    requestError: "",

    // Pagination state

    // limit: 0,
    // page: 0,
    // nextPage: false,
    // prevPage: false,
    // totaldocs: 0,
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  componentDidMount() {
    this.testimonials();
  }

  handleRequestError = (error, fallbackState = {}) => {
    this.setState({
      ...fallbackState,
      delLoading: false,
      requestError:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to process testimonials",
    });
  };

  testimonials = () => {
    axios
      .get(Constants.getUrls.testimonials)
      .then((resp) => {
        console.log(resp);

        this.setState(
          {
            testimonials: resp.data.data,
            requestError: "",
          },
          () => {
            console.log(this.state.testimonials);
          }
        );
      })
      .catch((error) => {
        this.handleRequestError(error, { testimonials: [] });
      });
  };

  handleModal = (play) => {
    this.setState(
      {
        rowId: play._id,
        visible: true,
      },
      () => {
        console.log(this.state.visible);
      }
    );
  };
  handleDelete = () => {
    this.setState({
      delLoading: true,
    });
    let payload = {
      _id: this.state.rowId,
    };
    if (init() == "success") {
      // this.setState({ delLoading: true });
      axios
        .delete(Constants.putUrls.deleteTestimonial + this.state.rowId)
        .then((res) => {
          console.log(res);
          this.setState({
            notifyDelete: true,
            delLoading: false,
            delMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({ notifyDelete: false, visible: false }, () => {
              this.testimonials();
            });
          }, 2000);
        })
        .catch((error) => {
          this.handleRequestError(error, { visible: false });
        });
    }
  };

  handleStatus = (e, status, id) => {
    if (init() === "success") {
      this.setState(
        {
          [e.target.name]: e.target.value,
        },
        () => {
          const payload = {
            status: status,
          };
          console.log(payload);
          axios
            .post(Constants.statusUrl + id + "?type=blogs", payload)
            .then((res) => {
              console.log(res);
              this.setState({
                notifyStatus: true,
              });
              setTimeout(() => {
                this.setState({ notifyStatus: false }, () => {
                  this.testimonials();
                });
              }, 1000);
            })
            .catch((error) => {
              this.handleRequestError(error);
            });
        }
      );
    }
  };

  handleSelect = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (init() === "success") {
          axios
            .get(
              Constants.getUrls.testimonials +
                `?limit=${this.state.limit}` +
                `&page=${this.state.page}`
            )
            .then((resp) => {
              console.log(resp);
              this.setState({
                testimonials: resp.data.data || [],
                limit: resp.data.pagination.limit,
                nextPage: resp.data.pagination.nextpage,
                page: resp.data.pagination.page,
                prevPage: resp.data.pagination.prevpage,
                requestError: "",
              });
            })
            .catch((error) => {
              this.handleRequestError(error);
            });
        }
      }
    );
  };

  handleNext = () => {
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.testimonials +
            `?limit=${this.state.limit}` +
            `&page=${this.state.page + 1}`
        )
        // axios.get('http://localhost:8084/testimonials')
        .then((resp) => {
          console.log(resp);
          this.setState({
            testimonials: resp.data.data,
            limit: resp.data.pagination.limit,
            nextPage: resp.data.pagination.nextpage,
            page: resp.data.pagination.page,
            prevPage: resp.data.pagination.prevpage,
            // totaldocs: resp.data.pagination.totaldocs,
            requestError: "",
          });
        })
        .catch((error) => {
          this.handleRequestError(error);
        });
    }
  };

  handlePrev = () => {
    if (init() === "success") {
      axios
        .get(
          Constants.getUrls.testimonials +
            `?limit=${this.state.limit}` +
            `&page=${this.state.page - 1}`
        )
        // axios.get('http://localhost:8084/testimonials')
        .then((resp) => {
          console.log(resp);
          this.setState({
            testimonials: resp.data.data,
            limit: resp.data.pagination.limit,
            nextPage: resp.data.pagination.nextpage,
            page: resp.data.pagination.page,
            prevPage: resp.data.pagination.prevpage,
            // totaldocs: resp.data.pagination.totaldocs,
            requestError: "",
          });
        })
        .catch((error) => {
          this.handleRequestError(error);
        });
    }
  };
  // Pagination code end
  render() {
    return (
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(this.state.requestError)}
          autoHideDuration={4000}
          onClose={() => this.setState({ requestError: "" })}
          message={this.state.requestError}
        ></Snackbar>
        {/* <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={true}
            color={"s"}
            autoHideDuration={6000}
            message="I love snacks"
          ></Snackbar> */}
        {this.state.notifyDelete ? (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={true}
            color={"s"}
            autoHideDuration={6000}
            // message={this.state.delMsg}
            message={"Deleted Successfully !!"}
          ></Snackbar>
        ) : null}
        <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h6">
              {/* {this.props.title} */}
              Testimonials
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Grid container justify="flex-end">
              {/* <FormControl style={{ marginRight: 10 }}>
                <TextField
                  id="outlined-basic"
                  placeholder={"Search " + this.props.title}
                  size="small"
                  variant="outlined"
                  onClick={this.handleSearch}
                />
              </FormControl> */}
              <Link
                to="/admin/addTestimonial"
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="medium"
                  onClick={() => {
                    this.setState({ open: true });
                  }}
                  variant="contained"
                  color="primary"
                >
                  Add New
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <br></br>
        <Grid item sm={12}>
          <Paper elevation={1}>
            <TableContainer>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "200px" }}> S.No</TableCell>
                    <TableCell>Title</TableCell>
                    {/* <TableCell>Message</TableCell> */}
                    <TableCell>Image</TableCell>
                    <TableCell align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {(rowsPerPage > 0
                          ? rows.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            ) */}
                  {this.state.testimonials.map((play, i) => (
                    <TableRow key={play.title}>
                      <TableCell>{i + 1}</TableCell>
                      <TableCell component="th" scope="row">
                        {play.name}
                      </TableCell>

                      {/* <TableCell component="th" scope="row">
                        {play.content == null
                          ? ""
                          : renderHTML(play.content.substring(0, 100))}
                      </TableCell> */}
                      <TableCell>
                        <img
                          src={Constants.imgDomain + play.image}
                          alt=""
                          style={{
                            height: "100px",
                            width: "100px",
                          }}
                        />
                      </TableCell>

                      <TableCell align="right">
                        <Link
                          to={{
                            pathname: "/admin/updateTestimonial/" + play._id,
                            state: { data: play },
                          }}
                          style={{ textDecoration: "none" }}
                        >
                          <Button
                            variant={"outlined"}
                            color="default"
                            style={{ marginRight: 4 }}
                            size={"small"}
                          >
                            Update
                          </Button>
                        </Link>
                        <Button
                          size={"small"}
                          variant={"outlined"}
                          color="secondary"
                          onClick={() => {
                            this.handleModal(play);
                          }}
                          style={{ marginTop: "5px", marginRight: "5px" }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )} */}
                </TableBody>
              </Table>
              <TableRow
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <div>
                  <p>
                    Showing {this.state.page} to {this.state.limit} of{" "}
                    {this.state.total} Entries
                  </p>
                </div>

                {/* Rows PerPage START */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "200px",
                  }}
                >
                  <p>Rows Per Page</p>

                  <FormControl
                    className="selectMerchants"
                    style={{ marginRight: "20px", marginTop: "-12px" }}
                  >
                    <InputLabel htmlFor="age-native-simple"></InputLabel>
                    <Select
                      native
                      value={this.state.limit}
                      onChange={this.handleSelect}
                      inputProps={{
                        name: "limit",
                        id: "age-native-simple",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Select>
                  </FormControl>
                </div>
                {/* Rows PerPage END */}

                <div>
                  <Button
                    variant="contained"
                    color="secondary"
                    className="mx-5"
                    style={{ margin: "10px" }}
                    disabled={this.state.prevPage === false}
                    onClick={this.handlePrev}
                    // Hidden
                  >
                    Previous
                  </Button>{" "}
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-5"
                    disabled={this.state.nextPage === false}
                    style={{ margin: "10px" }}
                    onClick={this.handleNext}
                  >
                    Next
                  </Button>
                </div>
              </TableRow>
            </TableContainer>
          </Paper>
        </Grid>
        <Modal
          visible={this.state.visible}
          width="450"
          height="80"
          effect="fadeInUp"
          onClickAway={() => this.setState({ visible: false })}
        >
          <Row>
            <Col sm={12} xs={12} md={12}>
              <Card>
                <CardBody>
                  <div className="modal">
                    <h3 className="changeColor">
                      Are you sure you want to Delete?
                    </h3>

                    {this.state.notifyDelete ? (
                      <Snackbar
                        message="Deleted Successfully !!"
                        autoHideDuration={6000}
                        color="s"
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open="true"
                      ></Snackbar>
                    ) : null}
                    <Row>
                      <Col xs={12} sm={12} md={4}>
                        <br />
                        <Button
                          className=""
                          color="secondary"
                          variant="contained"
                          style={{ margin: "20px" }}
                          onClick={() => {
                            this.handleDelete(this.state.rowId);
                          }}
                        >
                          {this.state.delLoading ? "Deleting..." : "Yes"}
                        </Button>
                        <Button
                          className=""
                          color="primary"
                          variant="contained"
                          style={{ margin: "20px", marginLeft: "4px" }}
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          NO
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Modal>
      </Container>
    );
  }
}
